<div [class.has-design-context]="!!linkedLineItemCount" class="wrapper">
  <div class="heading text-type-5">{{ data?.bidItem?.item }}</div>
  <div class="description text-type-10">{{ data?.bidItem?.description }}</div>
  <div class="meta text-type-14">
    {{ data?.bidItem?.source_entity_extra_attributes?.project_name }}
    · PRJ LINE: {{ data?.bidItem?.source_entity_extra_attributes?.project_item_line_number }}
    · LINE: {{ data?.bidItem?.source_entity_extra_attributes?.contract_item_line_number }}
    @if (data?.bidItem?.source_entity_extra_attributes?.supplemental_description) {
      · {{ data?.bidItem?.source_entity_extra_attributes.supplemental_description | uppercase }}
    }
  </div>
  <div class="count text-type-14 mt-[10px]">{{ data?.totalLineItemCount || 0 }} {{ (data?.totalLineItemCount || 0) === 1 ? 'entry' : 'entries' }}</div>
  @if (linkedLineItemCount) {
    <div class="card-linked-count text-type-14" data-testid="design-context-linked-count">{{ linkedCountText(linkedLineItemCount) }}</div>
  }
</div>
